












import Vue from 'vue'
import AppHeader from '@/views/app-header/app-header.vue'
import DdMobileMenu from '@/components/global/dd-mobile-menu.vue'

export default Vue.extend({
  name: 'DefaultLayout',

  components: {
    AppHeader,
    DdMobileMenu,
  },

  props: {
    unstickHeader: {
      type: Boolean,
      default: false,
    },
    hideMobileBackButton: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      searchActive: false,
    }
  },

  methods: {
    toggleSearch(val: boolean) {
      this.searchActive = val
      if (this.$screen.isMobile(this.$mq)) {
        if (val === true) {
          this.$bodyScroll.disable()
        } else {
          this.$bodyScroll.enable()
        }
      }
    },
  },
})
